export const environment = {
  production: false,
  linu_firma_accion: window['__env']['linu_firma_accion'],
  linu_firma_rutaDestino: window['__env']['linu_firma_rutaDestino'],
  linu_firma_rutaOrigen: window['__env']['linu_firma_rutaOrigen'],
  linu_firma_urlConfigService: window['__env']['linu_firma_urlConfigService'],
  linu_firma_webService: window['__env']['linu_firma_webService'],
  linu_licApi_presentacionUrl: window['__env']['linu_licApi_presentacionUrl'],
  linu_punku_api_changePasswordUrl: window['__env']['linu_punku_api_changePasswordUrl'],
  linu_punku_api_loginUrl: window['__env']['linu_punku_api_loginUrl'],
  linu_punku_api_logoutUrl: window['__env']['linu_punku_api_logoutUrl'],
  linu_punku_guidSistema: window['__env']['linu_punku_guidSistema'],

};